import React from 'react'
import { Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const BadgeCard = (props) =>{
    return(
        <Card className = "shadow">
        <Card.Body>
            
            <Card.Title>{props.title}</Card.Title>
            <span className = {props.badgeColor + " position-absolute top-0 start-100 translate-middle p-2  border border-light rounded-circle"}>
                <span className="visually-hidden">New alerts</span>
            </span>
            <hr className="dropdown-divider"/>
            <Card.Text className = "h-50">
            {props.p}
            </Card.Text>
            
            <Link to = {props.Link}>Ver animación</Link>
        </Card.Body>
        </Card>
    )
}

export default BadgeCard